module.exports = __webpack_public_path__ + "static/exhibitors-background-colored.63cfd384.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/exhibitors-background-colored.jpg
// module id = 906
// module chunks = 101932004231744